import Swal from 'sweetalert2'

// Vue.use(AlertPlugin);
// Vue.use(ConfirmPlugin);

/*
alert 관련 메시지 이벤트 저장 후 사용
 */

export default {
    methods: {
        createAlert(params){
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.btnText ? '확인' : params.btnText,
                customClass : !params.customClass ? 'alert_default' : params.customClass,
                onClose: () => {
                    if(params.back){
                        window.history.back();
                    }else if(params.hide) {
                        params.hide();
                    }
                }
            })
        },
        createConfirm(params){
            Swal.fire({
                title: !params.title ? '' : params.title,
                html: !params.content ? '' : params.content,
                confirmButtonText: !params.confirmText ? '확인' : params.confirmText,
                cancelButtonText: !params.cancelText ?'취소' : params.cancelText,
                showCancelButton: true,
                customClass:'alert_default confirm_msg',
                // showCloseButton: true,
                // allowOutsideClick: false,
            }).then((result) => {
                if (result.value) {
                    if(params.confirm)
                        params.confirm();
                } else {ㅐ
                    if(params.cancel)
                        params.cancel();
                }
            })
        },
        errorAlert(params){
            Swal.fire({
                title: '',
                html: params,
                confirmButtonText: '확인',
                customClass:'alert_default',
                onClose: () => {

                }
            })
        },
        errorAlert2(params){
            Swal.fire({
                title: '',
                html: params,
                confirmButtonText: '확인',
                onClose: () => {

                }
            })
        },
        doubleButtonAlert(params){
            Swal.fire({
                showConfirmButton:true,
                showCancelButton:true,
                confirmButtonText:'검침 내역',
                cancelButtonText:'지도 바로가기',
                customClass:'double_b_alert',
            }).then((result) => {
                if (result.value) {
                    if(params.confirm)
                        params.confirm();
                } else if(result.dismiss === 'cancel') {
                    if(params.cancel)
                        params.cancel();
                }
            });
        }

    }
}
